var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group mb-3"},[_c('input',{staticClass:"w-100p",attrs:{"placeholder":_vm.$t('search.placeholder'),"type":"text"},on:{"input":function($event){return _vm.$emit('update', $event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }